import $ from 'jquery';
import ResourceEvents from '../classes/resource-events.class';
import FormEvents from '../classes/form-events.class';

export default function events() {
  const resourceEvents = new ResourceEvents();
  resourceEvents.init();

  if ($('#homepage-search-form').length) {
    const formEvents = new FormEvents(
      '#homepage-search-form',
      'search-form-homepage-started',
      'search-form-homepage-submit',
      true // force submit
    );
    formEvents.init();
  }

  if ($('.js-inquire-form').length) {
    const formEvents = new FormEvents(
      '.js-inquire-form',
      'inquire-form-global-started',
      'inquire-form-global-submit'
    );
    formEvents.init();
  }

  if ($('.js-meeting-form').length) {
    const formEvents = new FormEvents(
      '.js-meeting-form',
      'meet-form-global-started',
      'meet-form-global-submit'
    );
    formEvents.init();
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/project/events.js